import type { ComponentProps } from 'react';

import {
  TableActionButton,
  TableCardHeader,
  TableCardTitle,
  TableNote,
  TableCell,
  TableDropdownList,
  TableGroup,
  TableHead,
  TableHeadRow,
  TableInfo,
  TableLoader,
  TableNoData,
  TablePagination,
  TableRow,
  usePageInfo,
  usePagination,
} from './components/index.ts';
import { StyledTable, TableScrollableWrapper, TableWrapper } from './styled.ts';

const Component = ({ maxHeight, ...props }: ComponentProps<typeof StyledTable> & { maxHeight?: number }) => (
  <TableScrollableWrapper $maxHeight={maxHeight}>
    <StyledTable {...props} />
  </TableScrollableWrapper>
);

export const Table = Object.assign(Component, {
  ActionButton: TableActionButton,
  CardHeader: TableCardHeader,
  CardTitle: TableCardTitle,
  Note: TableNote,
  Cell: TableCell,
  DropdownList: TableDropdownList,
  Group: TableGroup,
  Head: TableHead,
  HeadRow: TableHeadRow,
  Info: TableInfo,
  Loader: TableLoader,
  NoData: TableNoData,
  Pagination: TablePagination,
  Row: TableRow,
  Wrapper: TableWrapper,
  usePageInfo,
  usePagination,
});
